import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AccountSummaryFragment,
    GetAccountSummary as GetAccountSummaryQuery,
    GetAccountSummaryVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_SUMMARY from '../queries/get-account-summary.graphql';

export function useGetAccountSummary(
    accountId: string,
    skip: boolean = false
): {
    accountSummary: AccountSummaryFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetAccountSummaryQuery,
        GetAccountSummaryVariables
    >(GET_ACCOUNT_SUMMARY, {
        variables: {id: accountId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        accountSummary: data?.account ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
